export default __webpack_public_path__ + "static/media/cancel.c7472748.png";